import { BaseUIStore } from 'internal'

const SuggestedUIStore = BaseUIStore.named('SuggestedUIStore')

export default SuggestedUIStore
